const COMMON_CATEGORIES = {
  wetFood: 'Nassfutter',
  dryFood: 'Trockenfutter',
  barf: 'Frische-Menüs',
  snacks: 'Snacks',
  barfTastingPacks: 'Frische-Menü-Probierpakete',
  notMov: 'notmov',
  bundle: 'Bundle',
} as const;

export default COMMON_CATEGORIES;
